import React from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProductListingInsideModal from '../Presentation/ProductListingInsideModal';
import ProductListingModalForm from '../Presentation/ProductListingModalForm';
import PRODUCT_CONSTANTS from '../Constants/ProductListingModalOptionsConstants';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { isEmptyObject } from 'common/utilities/utils';

const filteredModGroups = data => {
  if (data) {
    let dataObj = JSON.parse(JSON.stringify(data));
    dataObj.modgrps = data.modgrps?.filter(({ isHidden }) => !isHidden);
    return dataObj;
  }
  return {};
};
const ProductListingModalOptions = props => {
  const { isModal = true, showPriceContent = true, callBackToPDP, data = {}, source = '' } = props;

  const { MODALHEADERTEXT = '' } = PRODUCT_CONSTANTS;

  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer.currentItemDetails);
  const curreItemDetailsUpdated = isEmptyObject(data) ? filteredModGroups(data) : filteredModGroups(currentItemDetails);
  const dispatch = useDispatch();
  const cartReducer = useSelector(data => data.cartReducer);

  /**
   *
   * @param {*} element - method to handle close of the modal
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    dispatch(showCustomizationModalAction({ showProductListingModal: false, categorySelected: '' }));
  };

  const productListingModalForm = (
    <ProductListingModalForm
      data={curreItemDetailsUpdated}
      categoryId={cartReducer.categorySelected}
      handleClose={handleClose}
      showPriceContent={showPriceContent}
      callBackToPDP={callBackToPDP}
      data-testid='product-listing-modal-enabled'
      source={source}
    />
  );
  const renderElement = (
    <ProductListingInsideModal
      handleClose={handleClose}
      ProductListingModalForm={productListingModalForm}
      headerText={translateWithI18Next(MODALHEADERTEXT)}
      data-testid='product-listing-inside-modal'
    />
  );

  const pdpCustomizations = <div className='pdp-custm'>{productListingModalForm}</div>;
  return !isModal ? pdpCustomizations : ReactDOM.createPortal(renderElement, document.getElementById('modal-popups'));
};

export default ProductListingModalOptions;
